import { posthog } from 'config/posthog';

export interface PersonProperties {
    $set: Record<string, unknown>;
    $set_once: Record<string, unknown>;
}

// The app-level identify runs in an ancestor effect (after descendants) and only once
// Firebase is ready, so view events identify themselves first. Same-id identify is a no-op.
export const identifyPosthogUser = (userId: string) => {
    if (posthog?.get_distinct_id?.() !== userId) {
        posthog?.identify?.(userId);
    }
};

// Person properties for survey targeting, merged into the event's own capture call.
export const viewedPersonProperties = (prefix: 'coord_dash' | 'invite_hub'): PersonProperties => {
    const now = new Date().toISOString();
    return {
        $set: { [`${prefix}_last_viewed_at`]: now },
        $set_once: { [`${prefix}_first_viewed_at`]: now },
    };
};

export const engagedPersonProperties = (): PersonProperties => {
    const now = new Date().toISOString();
    return {
        $set: { invite_hub_last_engaged_at: now },
        $set_once: { invite_hub_first_engaged_at: now },
    };
};
